import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import ShipmentDetailMobile from "../mobile/logistics/ShipmentDetailMobile";
import ShipmentDetail from "./pages/ShipmentDetail";

export default function ResponsiveShipmentDetail(props) {
  return useIsMobile() ? <ShipmentDetailMobile {...props} /> : <ShipmentDetail {...props} />;
}
